import { useEffect, useState } from 'react';
import {
  getValueMetrics,
  getQualityBar,
  getOutcomes,
} from '@/services/mockData';
import { DetailShell } from '../../detail/DetailShell';
import { Card } from '../../detail/Card';
import { SectionTitle } from '../../detail/SectionTitle';

// Value Delivery — KPI grid (4 cards) + outcomes/quality bar split.

export function ValueDetail({ onClose }) {
  const [data, setData] = useState({ metrics: null, quality: null, outcomes: null });
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    Promise.all([getValueMetrics(), getQualityBar(), getOutcomes()])
      .then(([metrics, quality, outcomes]) => {
        if (!cancelled) setData({ metrics, quality, outcomes });
      })
      .catch((e) => { if (!cancelled) setError(e); });
    return () => { cancelled = true; };
  }, []);

  if (error) {
    return (
      <DetailShell eyebrow="07 · Delivery Dashboard" title="Value Delivery" onClose={onClose}>
        <div className="font-mono text-mono-tag uppercase text-danger">Could not load value data</div>
      </DetailShell>
    );
  }
  if (!data.metrics) {
    return (
      <DetailShell eyebrow="07 · Delivery Dashboard" title="Value Delivery" onClose={onClose}>
        <div className="font-mono text-mono-tag uppercase text-ink-3">Loading…</div>
      </DetailShell>
    );
  }

  return (
    <DetailShell eyebrow="07 · Delivery Dashboard" title="Value Delivery" onClose={onClose}>
      <div className="grid grid-cols-4 gap-4">
        {Object.entries(data.metrics).map(([k, m]) => (
          <Card key={k}>
            <div className="font-mono text-[10px] uppercase tracking-[0.06em] text-ink-3">{k}</div>
            <div className="font-serif text-[36px] leading-none">{m.value}</div>
            <div className="font-mono text-[11px] text-accent-ink">{m.delta}</div>
            <div className="font-mono text-[10px] uppercase tracking-[0.06em] text-ink-3">{m.label}</div>
          </Card>
        ))}
      </div>

      <div className="grid grid-cols-2 gap-4">
        <Card>
          <SectionTitle label="Outcomes, not deliverables" meta="CAPABILITY BUILT" />
          <div className="grid gap-2.5">
            {data.outcomes.map((o) => (
              <div
                key={o.id}
                className="grid items-start gap-2.5"
                style={{ gridTemplateColumns: '140px 1fr 1fr' }}
              >
                <div className="font-serif text-[15px]">{o.client}</div>
                <div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.06em] text-ink-3">OUTCOME</div>
                  <div className="text-[13px]">{o.outcome}</div>
                </div>
                <div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.06em] text-ink-3">DELIVERABLE</div>
                  <div className="text-[13px] text-ink-3">{o.deliverable}</div>
                </div>
              </div>
            ))}
          </div>
        </Card>

        <Card>
          <SectionTitle label="Quality bar" meta="CRITERIA" />
          <div className="grid gap-2.5">
            {data.quality.map((q) => (
              <div
                key={q.id}
                className="grid items-start gap-2.5"
                style={{ gridTemplateColumns: '140px 1fr' }}
              >
                <div className="font-serif text-[16px]">{q.dimension}</div>
                <div className="text-[13px] text-ink-2">{q.target}</div>
              </div>
            ))}
            <div className="font-mono text-[10px] uppercase tracking-[0.06em] text-accent-ink mt-1">
              COACH PROPOSAL · ACCEPTED 09:12 — Knowledge Transfer raised to standard.
            </div>
          </div>
        </Card>
      </div>
    </DetailShell>
  );
}

export default ValueDetail;
